import { apiAuth } from "../../http";

export const patchStoryById = async (id: string, body: any): Promise<any> => {
  const response = apiAuth()
    .patch(`/stories/${id}`, body)
    .then(({ data }) => data);
  return response;
};
